import React from 'react';
import classNames from 'classnames';

import css from './BooleanFilter.module.css';

const BooleanFilter = props => {
  const {
    className,
    rootClassName,
    label,
    queryParamNames,
    initialValues,
    onSubmit,
  } = props;

  const paramName = queryParamNames?.[0];
  const currentValue = initialValues?.[paramName];
  const isChecked = currentValue === 'true';
  const classes = classNames(rootClassName || css.root, className);

  const handleChange = () => {
    // ON → send 'true' to add param to URL; OFF → send null to remove param from URL
    const newValue = isChecked ? null : 'true';
    onSubmit({ [paramName]: newValue });
  };

  return (
    <div className={classes}>
      <label className={css.label} htmlFor={`filter-${paramName}`}>
        <input
          id={`filter-${paramName}`}
          type="checkbox"
          className={css.checkbox}
          checked={isChecked}
          onChange={handleChange}
        />
        <span className={css.track} />
        <span className={css.text}>{label}</span>
      </label>
    </div>
  );
};

export default BooleanFilter;
